// extracted by mini-css-extract-plugin
export default {"wrapperInner":"wrapperInner--fP7Nu","root":"root--GtmXJ","collapseContainer":"collapseContainer--N7saX"};